import { ProgCss } from "./ProgCss.Generated";
import { cast, castOrNull } from "./tools";
import { addTooltipToTarget } from "./tooltips";

export function WireupKolomHoverVoorLijsten(scopeEl: HTMLElement) {
    for (const table of scopeEl.getElementsByClassName(ProgCss.LijstContainer_table)) {
        const tableElem = cast(table, HTMLTableElement);
        let hoveredCellIndex = -1;
        tableElem.addEventListener("mouseover", hoverColumn);
        tableElem.addEventListener("mouseout", hoverColumn);
        function hoverColumn(evt: MouseEvent) {
            const genericLijstTableElem = cast(evt.currentTarget, HTMLTableElement);
            const targetElem = castOrNull(evt.target, HTMLElement);
            const cell = castOrNull(targetElem?.closest("td, th"), HTMLTableCellElement);
            const showHighlight = evt.type.toLowerCase() === "mouseover";
            if (cell //hovering a table cell
                && cell.closest("table") === genericLijstTableElem //...from this table, no other nested table
                && !(evt.relatedTarget instanceof Node && cell.contains(evt.relatedTarget)) //without moving entirely within the same table cell
                && cell.cellIndex > 1 // hovering the first (row-number) column isn't relevant
                && !cell.classList.contains(ProgCss.LijstContainer_columnGroup) // column-groups can't be highlighted
                && !(!showHighlight && evt.relatedTarget instanceof Element && evt.relatedTarget.classList.contains(ProgCss.is_columnHovered)) //without moving between cells of the same column
            ) {
                setColumnHoverState(genericLijstTableElem, cell.cellIndex, showHighlight);
                if (showHighlight && hoveredCellIndex !== cell.cellIndex) {
                    //clean up corner cases whereby the element changes hover state not due to mouse-movement, but DOM changes (typically tooltips).
                    setColumnHoverState(genericLijstTableElem, hoveredCellIndex, false);
                    hoveredCellIndex = cell.cellIndex;
                }
            }
        }
    }
}

function setColumnHoverState(table: HTMLTableElement, cellIndex: number, showHighlight: boolean) {
    for (const row of table.rows) {
        const otherCell = row.cells[cellIndex];
        if (otherCell && !otherCell.classList.contains(ProgCss.LijstContainer_columnGroup)) {
            otherCell.classList.toggle(ProgCss.is_columnHovered, showHighlight);
        }
    }
}

export function WireUpHoverText(scopeEl: HTMLElement) {
    const boxes: HTMLElement[] = [];
    for (const box of scopeEl.getElementsByClassName(ProgCss.u_maxWidthLimited)) {
        if (box instanceof HTMLElement && box.scrollWidth > box.clientWidth) {
            boxes.push(box);
        }
    }
     // Eerst alles gefiltered en dan pas DOM mutatie om client side load te verlagen ivm reflow
    for (const box of boxes) {
        const clone = box.cloneNode(true); // clone nodig om de tooltip op te baseren
        disablePointerEventsOfChildren(box); // eerst gecloned voor pointer events disabelen
        addTooltipToTarget(box, Array.from(clone.childNodes), box.getAttribute("data-undashed") === "true", false);
    }
}

function disablePointerEventsOfChildren(target: Element) {
    for (const child of target.children) {
        if (child instanceof HTMLElement) {
            child.style.pointerEvents = "none";
        }
    }
}

